<template>
  <SogCard :class="_classCard">
    <SogCardContent>
      <PersonAddressComponent
        :person="person"
        :address="address"
      />
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">
import Person from "@/shared/model/person";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import PersonAddressComponent from "@/modules/OrganisationStructure/components/PersonAddressComponent.vue";
import Address from "@/shared/model/Address";
import {computed} from "vue";


interface Props {
  person?: Person
  address?: Address
  allowSelect?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    person: undefined,
    address: undefined,
    allowSelect: false
  }
)
const _classCard = computed(() => {
  let res = "sog-card"
  /*
    if(props.isSelected){
      res += " selected"
    }
  */
  if (props.allowSelect) {
    res += " allow-select"
  }
  return res

})

</script>

<style scoped>
td {
  padding-right: 10px;
}

/*.sog-card{
  /*
  min-width: 100px;
  width: auto;

  padding-top: 12px;
}*/
.sog-card {
  min-width: 250px;
  width: 250px;
  padding-top: 12px;
}

.selected {
  background-color: #4b5563;
  border: 1px solid #22d3ee;
  color: #fff;
}

.allow-select {
  cursor: pointer;
}

/*.e-card-content{font-size:14px;line-height:1.5;padding:0 18px 12px 18px}
*/
.sog-card {
}
</style>
